import { RadioButtonGroup } from '../NarusMaterial'

import { makeAutobindedInput, makeValidatedInput } from './FormBuilder'

export const RadioGroupField = props => {
  const { label, errors, ...rest } = props

  const className = [ 'nh-sub-head' ]

  if (errors) {
    className.push('error')
  }

  return (
    <div>
      <span className={className.join(' ')}>{label}</span>
      <div>
        <RadioButtonGroup
          errors={errors}
          {...rest}
        />
      </div>
    </div>
  )
}

export const RadioGroupInput = makeAutobindedInput(
  makeValidatedInput(RadioGroupField)
)
